// Real replies from the product's original Reddit launch thread, trimmed for
// length (openers/closers like "This is incredible!" cut, the substantive
// claim kept verbatim). Attribution is the commenter's own public handle --
// the same one visible on that thread.
//
// Picked for the same reason across all three: each describes the tool being
// genuinely USEFUL -- a concrete before/after, a specific use case, a real
// time saved -- rather than reacting to the launch itself. A thread like this
// one is mostly launch-day excitement ("genius!", "you rock!"), and that
// excitement is exactly what got filtered out: it reads as hype, not proof.
// One near-miss worth noting: an earlier pick ("I just put up some treatment
// like a blind man in the dark, and it really helped... can't wait to try
// out your software") was dropped on a closer read -- "it really helped"
// describes the commenter's OWN manual panels, not the tool, which they say
// outright they hadn't used yet.
export interface Testimonial {
  quote: string;
  /** A short, punchy fragment of the same quote, for tight layouts (the
   *  pre-upsell's three-column strip) where a full sentence doesn't fit. */
  short: string;
  author: string;
  context?: string;
}

export const TESTIMONIALS: Testimonial[] = [
  {
    quote:
      'The thought of treating in terms of where to place what of which dimensions has been a bit overwhelming. But I feel a lot more confident with this.',
    short: 'A lot more confident with this',
    author: 'u/Dananias',
  },
  {
    quote:
      'I already have some fairly decent treatment in my room, but having this visual is such a nice to have. Takes minutes to pump in your numbers.',
    short: 'Takes minutes to pump in your numbers',
    author: 'u/Rayjubb87',
  },
  {
    quote: 'Even if just approximate, it can be very useful for early reflection points.',
    short: 'Very useful for early reflection points',
    author: 'u/Outside_Ninja_7907',
  },
];
